import SiteHeader from '@/pages/home/components/SiteHeader';
import HeroSection from '@/pages/home/components/HeroSection';
import ArchiveSection from '@/pages/home/components/ArchiveSection';
import TimelineSection from '@/pages/home/components/TimelineSection';
import TopicIndexSection from '@/pages/home/components/TopicIndexSection';
import UpdateFeedSection from '@/pages/home/components/UpdateFeedSection';
import TrustSection from '@/pages/home/components/TrustSection';
import CommunitySection from '@/pages/home/components/CommunitySection';
import FaqSection from '@/pages/home/components/FaqSection';
import SubscribeSection from '@/pages/home/components/SubscribeSection';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50 font-body text-foreground-950">
      <SiteHeader />
      <main className="w-full flex-1">
        <HeroSection />
        <ArchiveSection />
        <TimelineSection />
        <TopicIndexSection />
        <UpdateFeedSection />
        <TrustSection />
        <CommunitySection />
        <FaqSection />
        <SubscribeSection />
      </main>
      <SiteFooter />
    </div>
  );
}